module.exports = __webpack_public_path__ + "static/media/21ECLAC40.e00909f3.jpg";